angular.module("carto-iti").factory("CartoService", ["$http", "ENV", "OkinaLeafletService", "$sanitize", function ($http, ENV, OkinaLeafletService, $sanitize) {

	/**
	 * API
	 */
	return {
		/** HTTP REQUESTS **/
		getInstitutions: getInstitutions,
		getInstitutionsForMap: getInstitutionsForMap,

		/** MAP OBJECT **/
		displayTopologyLine: displayTopologyLine,
		displayTopologyJourneyPattern: displayTopologyJourneyPattern,
		displayTopologyVehicleJourney: displayTopologyVehicleJourney,
		displayInstitutionCenter: displayInstitutionCenter,
		displayStopAreaServicing: displayStopAreaServicing,

		getStopAreaServicingPopupTemplate: getStopAreaServicingPopupTemplate,
		getStopAreaUsageColorPopupHtml: getStopAreaUsageColorPopupHtml
	};

	function getInstitutions() {
		return $http.get(ENV.API_URL + "/institution");
	}

	function getInstitutionsForMap() {
		return $http.get(ENV.API_URL + "/institution/map");
	}

	/**
	 * Affiche une ligne sur la carte
	 *
	 * @param line
	 * @param onClickCallback
	 */
	function displayTopologyLine(line, onClickCallback) {
		if (line.itineraires.length > 0) {
			const itineraire = line.itineraires[0];
			const paramStyle = {
				"color": "#" + line.couleur,
				"weight": 2
			};
			const properties = {
				lineId: line.id,
				onClick: onClickCallback
			};
			displayTopologyJourneyPattern(itineraire, paramStyle, properties, onClickCallback);
		}
	}

	/**
	 * Affiche une course sur la carte
	 *
	 * @param vehicleJourney
	 * @param styleWeight
	 * @param onClickCallback
	 */
	function displayTopologyVehicleJourney(vehicleJourney, styleWeight, onClickCallback) {
	    const shapeStyle = {
			color: '#' + (vehicleJourney.color || "000000"),
			weight: styleWeight || 2
		};

		OkinaLeafletService.addShapeGeoJson(formatGeoJson(vehicleJourney.geoJson), shapeStyle, {
			vehicleJourneyId: vehicleJourney.id,
			onClick: onClickCallback
		});
	}


	function isEmpty(obj) {
		for(const key in obj) {
			if(obj.hasOwnProperty(key))
				return false;
		}
		return true;
	}

	/**
	 * Affiche une course sur la carte
	 *
	 * @param journeyPattern
	 * @param paramStyle
	 * @param properties
	 * @param onClickCallback
	 */
	function displayTopologyJourneyPattern(journeyPattern, paramStyle, properties, onClickCallback) {
		const style = paramStyle || {
			color: "#3040ff",
			weight: 2
		};

		const shapeStyle = {
			"color": style.color,
			"weight": style.weight
		};

		const paramProperties = !isEmpty(properties) ? properties : {
			journeyPatternId: journeyPattern.id,
			onClick: onClickCallback
		};

		// Gestion du potentiel geoJson geojson problem
		const geojson = formatGeoJson(journeyPattern.geoJson || journeyPattern.geojson);
		OkinaLeafletService.addShapeGeoJson(geojson,  shapeStyle, paramProperties);
	}

	/**
	 * Affiche les markers des institutions du centre scolaire
	 * @param institutionCenter
	 * @param $scope, le scope a passer en paramètre
     * @param readOnly -> Détermine si on doit afficher les boutons pour l'édition d'un centre scolaire
	 */
	function displayInstitutionCenter(institutionCenter, $scope, readOnly) {
		for (let i = 0; i < institutionCenter.institutions.length; i++) {
			let institution = institutionCenter.institutions[i];
			let latitude = institution.locationY;
			let longitude = institution.locationX;

			if (latitude != null && typeof latitude !== "number") {
				latitude = parseFloat(latitude);
			}
			if (longitude != null && typeof longitude !== "number") {
				longitude = parseFloat(longitude);
			}

			const leafletInstitutionPoint = {
				lat: latitude,
				lng: longitude,
				id: institution.id,
				icon: {
					type: "awesomeMarker",
					icon: "university",
					prefix: "fa",
					markerColor: "red"
				},
				message: getInstitutionPopupTemplate(institution, readOnly ? null : "remove"),
				getMessageScope: $scope ? () => $scope : null
			};

			OkinaLeafletService.createMarker(leafletInstitutionPoint);
		}
	}

	/**
	 * Affiche les markers de la desserte scolaire
	 *
	 * @param stopPointServicing
	 * @param $scope
     * @param vehicleJourneyId
	 * @param onClickAction
	 */
	function displayStopAreaServicing(stopPointServicing, $scope, vehicleJourneyId, onClickAction) {
		let latitude = stopPointServicing.latitude;
		let longitude = stopPointServicing.longitude;

		if (latitude != null && typeof latitude !== "number") {
			latitude = parseFloat(latitude);
		}
		if (longitude != null && typeof longitude !== "number") {
			longitude = parseFloat(longitude);
		}

		let color = "blue";

		if (stopPointServicing.isDeparture) {
			color = "green";
		} else if (stopPointServicing.isArrival) {
			color = "red";
		}

		// Détermine si on doit chang er l'icone du marker ou non
		let hasAtLeastOneFillRateOver100 = false;
		stopPointServicing.vehicleJourneyAtStopViews.forEach(function (vjas) {
			if (vjas.fillingRateReal > 100 || vjas.fillingRateTheorical > 100) {
				hasAtLeastOneFillRateOver100 = true;
			}
		});

		const leafletServicingPoint = {
			lat: latitude,
			lng: longitude,
			id: stopPointServicing.id,
			vjasId: stopPointServicing.vjasId,
			saName: stopPointServicing.name,
			vehicleJourneyId: vehicleJourneyId,
			passingTimeRetrieved: stopPointServicing.vehicleJourneyAtStopViews.length !== 0,
			icon: {
				type: "awesomeMarker",
				icon: hasAtLeastOneFillRateOver100 ? "warning" : "circle",
				prefix: "fa",
				markerColor: color
			},
			popupMaxHeight: 200,
			popupMaxWidth: 600,
			onClick: onClickAction,
			message: getStopAreaServicingPopupTemplate(stopPointServicing, vehicleJourneyId),
			getMessageScope: $scope ? () => $scope : null
		};

		OkinaLeafletService.createMarker(leafletServicingPoint);
	}

	/** PRIVATE METHODS **/

	/**
	 * Transforme un geojson string en objet JS si besoin
	 * @param geoJson
	 * @returns {*}
	 */
	function formatGeoJson(geoJson) {
		let formatedGeoJson = geoJson;
		if (typeof geoJson === "string") {
			formatedGeoJson = JSON.parse(geoJson);
		}

		return formatedGeoJson;
	}

	/**
	 * Retourne le template de la popup d'un point d'arrêt pour la réaffectation de charge
	 * @param stopArea
	 * @param vehicleJourneyId
	 * @param isMorning
	 */
	function getStopAreaServicingPopupTemplate(stopArea, vehicleJourneyId, isMorning) {
		let vjsAtStop = "";
		let lstVjAtStop = stopArea.vehicleJourneyAtStopViews;

		const formatFillRateHTML = (up, down) => {
			if (up === 0 && down === 0) {
				return "-";
			}
			return up !== 0 ? (up + "<span class='fa fa-arrow-up'></span>") : "" +
			"&nbsp;" +
			down !== 0 ? (down + "<span class='fa fa-arrow-down'></span>") : ""
		};

		if (lstVjAtStop != null) {
			if (lstVjAtStop.length !== 0) {
				vjsAtStop += "<table style='width: 100%' class='table text-center'>";
				vjsAtStop += "<thead>" +
					"<tr>" +
					"   <th rowspan='2' class='text-center'>Course</th>" +
					"   <th rowspan='2' class='text-center'>Passage</th>" +
					"   <th colspan='3' class='text-center'>Taux Remplissage</th>" +
					"   <th rowspan='2'></th>" +
					"</tr>" +
					"<tr>" +
					"   <th>Affectés</th>" +
					"   <th>Pré-Affectés</th>" +
					"   <th>Att. Affectation</th>" +
					"</tr>" +
					"</thead>";
				vjsAtStop += "<tbody>";
				for (let i = 0; i < lstVjAtStop.length; i++) {
					const lstVjAtStopElement = lstVjAtStop[i];

					vjsAtStop += "<tr>";
					vjsAtStop += "<td>" + $sanitize(lstVjAtStopElement.vjName) + "</td>";
					vjsAtStop += "<td>" + lstVjAtStopElement.time + "</td>";

					console.log(lstVjAtStopElement);
					const stopPointFillRate = lstVjAtStopElement.stopPointFillRate;
					if (stopPointFillRate.fillRateBetweenStopsMaxAssignedActivated === 0 &&
						stopPointFillRate.fillRateBetweenStopsMaxAssignedPreassigned === 0 &&
						stopPointFillRate.fillRateBetweenStopsMaxAssignedPreassignedWaiting === 0) {
						vjsAtStop += "<td colspan='3'>Véhicule vide</td>";
					} else {
						vjsAtStop += "<td>" + formatFillRateHTML(stopPointFillRate.upAssigned, stopPointFillRate.downAssigned) + " </td>" +
							"<td>" + formatFillRateHTML(stopPointFillRate.upPreassigned, stopPointFillRate.downPreassigned) + " </td>" +
							"<td>" + formatFillRateHTML(stopPointFillRate.upWaiting, stopPointFillRate.downWaiting) + " </td>";
					}

					let shouldDisplaySelectSubAtStopButton = true;
					if (isMorning && lstVjAtStopElement.isArrival) {
						shouldDisplaySelectSubAtStopButton = false;
					} else if (!isMorning && lstVjAtStopElement.isDeparture) {
						shouldDisplaySelectSubAtStopButton = false
					}

					if (shouldDisplaySelectSubAtStopButton) {
						vjsAtStop += "<td><button class='btn btn-primary' " +
							"ng-click='selectSubscribersAtStop(" + lstVjAtStopElement.id + ", " + lstVjAtStopElement.vjId + ")'>" +
							"<span class='fa fa-exchange'></span>" +
							"</button></td>";
					}

					vjsAtStop += "</tr>";
				}
				vjsAtStop += "</tbody>";
				vjsAtStop += "</table>";
			} else {
				vjsAtStop += "<br>- Aucune Horaire de passage -";
			}
		} else {
			vjsAtStop = "<div class=\"text-center\">" +
				"<img width=\"100px\" src=\"assets/img/bus.svg\"/>" +
				"</div>";
		}

		return "<div class='olPopup'>" +
			"<h4>Point d'arrêt: " + $sanitize(stopArea.name) + "</h4>" +
			vjsAtStop +
			"</div>";
	}

	/**
	 * Retourne le template de la popup d'institution en fonction du type
	 * @param institution
	 * @param type -> Valeurs possible : add/remove
	 * @returns {string}
	 */
	function getInstitutionPopupTemplate(institution, type) {
		// Ajout de la balise parent pour le $compile
		let html = "<div>";

		// Lien vers l'institution
		html += "<a href=\"#/school-iti/institutions/" + institution.id + "\">" + $sanitize(institution.schoolEstablishmentDisplayName) + "</a>";

		if (institution.institutionCenterName != null && institution.institutionCenterId) {
			html += "<br/> Centre scolaire : <br/>" +
				"<a href=\"#/school-iti/institution-centers/" + institution.institutionCenterId + "\">" +
				"	<span class=\"sublabel-marker\">" + $sanitize(institution.institutionCenterName) + "</span>" +
				"</a>";
		}

		if (type) {
			// Ajout du bouton correspondant
			html += "<div class='text-center' ng-if='data.currentInstitutionCenter'><br/><button ";

			if (type === "add") {
				html += "ng-click='addInstitutionToCurrentInstitutionCenter(" + institution.id + ")' "
                    + "title='Si un centre scolaire est déjà associé a cet établissement il sera ecrasé par le nouveau centre scolaire.'"
                    + "class='btn btn-primary'>"
                    + "Ajouter";
			} else {
				html += "ng-click='removeInstitutionToCurrentInstitutionCenter(" + institution.id + ")'"
                    + "class='btn btn-warning text-center'>"
                    + "Retirer";
			}

			html += "</div></button>";
		}

		html += "</div>";
		return html;
	}

	function getStopAreaUsageColorPopupHtml(colorUsage) {
		let color, text;
		switch (colorUsage) {
			case "GRAY": // Arrêt inutilisé
				color = "gray";
				text = "L'arrêt n'est pas utilisé.";
				break;
			case "LIGHT_BLUE": // Arrêt utilisé, mais sans abonné dessus
				color = "lightblue";
				text = "L'arrêt est utilisé. Aucun abonné ne l'emprunte.";
				break;
			case "DARK_BLUE" : // Arrêt utilisé, mais avec des abonnés dessus
				color = "darkblue";
				text = "L'arrêt est utilisé. Des abonnés l'empruntent.";
				break;
		}
		return "<div class='pull-right margin-top-10'>"
			+ "<span title=\"" + text + "\" " +
			" style='background-color: "+color+"; width: 10px; height: 10px; padding: 2px 8px; border-radius: 50%'></span>"
			+ "</div>";
	}
}]);